import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5992e76a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lcts-card-mini-map-container" }
const _hoisted_2 = { class: "lcts-card-mini-map" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lcts-card-mini-card-content" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "lcts-card-learn-more",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.redirectToMarket()))
      }, " Saiba mais ")
    ])
  ]))
}